
export default {
  props: ['value'],
  methods: {
    onInput(e) {
      this.$emit('input', e.target.innerText);
    }
  }
}
